export function brandTransformName(name: string) {
  // to match API Brand.name_transform, which uses
  // https://apidock.com/rails/ActiveSupport/Inflector/parameterize
  return name.toLowerCase().replace(/[^a-z0-9\-_]+/g, '_');
}
